(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('BuscadorProyectosController', BuscadorProyectosController);

    BuscadorProyectosController.$inject = ['$scope', '$state', 'Auth', 'BuscadorProyectos', 'SSProyecto', 'ProgramaEducativo', 'centrosDocentes', 'periodos', 'ParseLinks', 'AlertService'];

    function BuscadorProyectosController($scope, $state, Auth, BuscadorProyectos, SSProyecto, ProgramaEducativo, centrosDocentes, periodos, ParseLinks, AlertService) {
        var vm = this;
        
        vm.searchForm = {};
        vm.search = search;
        
        vm.proyectoAccion = proyectoAccion;
        vm.proyectoDetalleSolicitud = proyectoDetalleSolicitud;
        
         periodos.$promise.then(function(periodos) {
        	vm.periodos = periodos;
        	vm.selectedPeriodo = periodos[0];
        	console.log(vm.selectedPeriodo);

	        centrosDocentes.$promise.then(function(centrosDocentes) {
	        	vm.centrosDocentes = [];
	            vm.centrosDocentes.push({id: 0, nombre: '- Todos'});         	
	        	vm.centrosDocentes = vm.centrosDocentes.concat(centrosDocentes);
	        	vm.selectedCentroDocente = vm.centrosDocentes[0];
	        	
	            BuscadorProyectos.programasEducativosByCentroDocente({
	            	idCentroDocente: vm.selectedCentroDocente.id,
	            }).$promise.then(function(programasEducativos) {
	            	vm.programasEducativos = [];
	                vm.programasEducativos.push({id: 0, nombre: '- Todos -'}); 
	                vm.programasEducativos = vm.programasEducativos.concat(programasEducativos);
	               	vm.selectedProgramaEducativo = vm.programasEducativos[0];
	            	loadProyectos();
	             });
	        });

        });
        
        function search() {
        	if(vm.searchForm.centroDocente.$dirty == true){
            	BuscadorProyectos.programasEducativosByCentroDocente({
                	idCentroDocente: vm.selectedCentroDocente.id,
            	}).$promise.then(function(programasEducativos) {
	    	    	vm.programasEducativos = [];
	    	        vm.programasEducativos.unshift({id: 0, nombre: '- Todos -'}); 
	    	        vm.programasEducativos = vm.programasEducativos.concat(angular.copy(programasEducativos));
	    	        vm.selectedProgramaEducativo = vm.programasEducativos[0];
	    	        loadProyectos();
	    	        vm.searchForm.centroDocente.$setPristine();
	            });
            } else {
            	loadProyectos();
            }
        }
        
        function loadProyectos(){
        	var centroDocente = vm.selectedCentroDocente.id;
        	if(vm.selectedProgramaEducativo.id != 0){
        		centroDocente = vm.selectedProgramaEducativo.centroDocente.id;
        	}
        	BuscadorProyectos.proyectosVigentes({
	        	idCentroDocente: centroDocente,
	        	idProgramaEducativo: vm.selectedProgramaEducativo.id,
    	       	fechaFin: vm.selectedPeriodo.finPeriodo,
	        }).$promise.then(function(proyectos) {
	        	vm.sSProyectos = proyectos;
	        });         	
        }
        
        function proyectoDetalleSolicitud(idProyecto, propagation, $event){
        	$state.go('buscador-proyectos-solicitud',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
                
        function proyectoAccion(idProyecto, propagation, $event){
       		$state.go('buscador-proyectos-solicitud',{id: idProyecto});
        	if(propagation == false){
        		$event.stopPropagation();        		
        	}
        }
    }
})();
